if (!customElements.get("bundle-builder-step")) {
    class BundleBuilderStep extends HTMLElement {
        constructor() {
            super();
            this.currentQuantity = 0;
            this.prevQuantity = 0;

        }

        connectedCallback() {
            this.quantityInputs = this.querySelectorAll(".quantity__input");
            this.plusButtons = this.querySelectorAll(".quantity__button[name=plus]");
            this.maxQuantity = this.dataset.max ? parseInt(this.dataset.max, 10) : 1;
            this.currentCountElement = this.querySelector(".bundle-builder__step-count .current-count")
            if (this.quantityInputs && this.quantityInputs.length > 0) {
                this.quantityInputs.forEach(input => {
                    input.addEventListener("change", this.handleQuantityChange.bind(this));
                });
            }
            this.updateProgressWidth();
            this.updateCurrentCount();
        }

        async handleQuantityChange(event) {
            const oldQuantity = this.currentQuantity;
            this.currentQuantity = this.getCurrentQuantity();

            // Eingabe über Limit verhindern
            if (this.currentQuantity > this.maxQuantity) {
                const allowed = this.maxQuantity - (this.currentQuantity - parseInt(event.target.value, 10));
                event.target.value = Math.max(0, allowed);
                this.currentQuantity = this.getCurrentQuantity();
            }

            const wasFull = oldQuantity >= this.maxQuantity;
            const isFull = this.currentQuantity >= this.maxQuantity;

            if (wasFull !== isFull) {
                this.togglePlusEnabled(isFull);
            }
            this.updateProgressWidth();
            this.updateCurrentCount();

            const wasValid = this.getAttribute("is-valid") === "true";
            const isNowValid = this.currentQuantity === this.maxQuantity;
            if (wasValid !== isNowValid) {
                this.setAttribute("is-valid", isNowValid ? "true" : "false");
                publish(PUB_SUB_EVENTS.bundleUpdate, {
                    id: this.id,
                    valid: isNowValid
                });
            }

            this.prevQuantity = this.currentQuantity;
        }

        togglePlusEnabled(disable) {
            this.plusButtons.forEach(button => {
                button.classList.toggle("disabled", disable);
                button.disabled = disable;
            });
        }

        getCurrentQuantity() {
            let sum = 0;
            this.quantityInputs?.forEach(input => {
                const value = parseInt(input.value, 10);
                if (!isNaN(value)) sum += value;
            });
            return sum;
        }
        updateProgressWidth() {
            const ratio = this.maxQuantity > 0 ? this.currentQuantity / this.maxQuantity : 0;
            const percentage = Math.min(100, Math.max(0, ratio * 100));
            this.style.setProperty("--progress-width", `${percentage}%`);
        }
        updateCurrentCount() {
            if (this.currentCountElement) {
                this.currentCountElement.textContent = this.currentQuantity;
            }
        }
    }

    customElements.define("bundle-builder-step", BundleBuilderStep);
}


if (!customElements.get("bundle-builder")) {
    class BundleBuilder extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.data_element = this.querySelector(".bundle_data");
            this.data = this.data_element ? JSON.parse(this.data_element.dataset.json) : null;
            this.steps = this.querySelectorAll("bundle-builder-step");
            this.submitButton = this.querySelector("button[type=submit]");
            this.form = this.querySelector("form")
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

            this.basePriceElement = this.querySelector(".bundle-builder__price .bundle-builder__price--base")
            this.calculatePriceElement = this.querySelector(".bundle-builder__price .bundle-builder__price--calculated")
            this.buttonPriceElement = this.querySelector(".button__price")
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.bundleUpdate, this.onBundleUpdate.bind(this));
            this.checkValidity();
            this.form.addEventListener("submit", this.onSubmitHandler.bind(this))
            this.form.addEventListener("change", this.calculatePrice.bind(this))
        }

        disconnectedCallback() {
            if (this.unsubscribe) this.unsubscribe();
            if (this.activeRenderAbortController) this.activeRenderAbortController.abort();
        }

        async onBundleUpdate(data) {
            this.checkValidity();
        }

        checkValidity() {
            if (!this.submitButton) return;

            const allValid = Array.from(this.steps).every(
                step => step.getAttribute("is-valid") === "true"
            );

            this.submitButton.disabled = !allValid;
            this.submitButton.classList.toggle("disabled", !allValid);
            this.togglePrice(allValid)
            return allValid
        }
        async onSubmitHandler(event) {
            event.preventDefault();
            if (!this.checkValidity()) return;
            const formData = new FormData(this.form);
            const bundleId = this.createBundleId();
            const items = [];
            const bundleSelection = [];
            let baseVariantId = null;

            for (const [key, value] of formData.entries()) {
                if (key.includes("base-variant")) {
                    baseVariantId = value;
                    continue;
                }
                if (key.includes("single-variant")) {
                    const id = value;
                    bundleSelection.push({ id, quantity: 1 });
                    continue;
                }
                if (key.includes("quantity-variant")) {
                    const parts = key.split("--");
                    const id = parts[parts.length - 1];
                    const quantity = parseInt(value, 10) || 0;

                    if (quantity > 0) {
                        bundleSelection.push({ id, quantity });
                    }
                    continue;
                }
            }

            this.calculatePrice()

            if (!baseVariantId) return console.warn("Keine Items im Bundle gefunden.");

            const itemToAdd = {
                id: baseVariantId,
                quantity: 1,
                properties: { 
                    "_bundle_selection": JSON.stringify(bundleSelection),
                    "_bundle_price": this.price || ""
                }
            }
            if(this.data.cart_title) itemToAdd.properties["_bundle_title"] = this.data.cart_title
            if(this.data.cart_image) itemToAdd.properties["_bundle_img"] = this.data.cart_image
            items.push(itemToAdd)
            const body = {
                items,
            };

            if (this.cart) {
                body.sections = this.cart.getSectionsToRender().map((section) => section.section || section.id);
                body.sections_url = window.location.pathname;
                this.cart.setActiveElement(document.activeElement);
            }
            const config = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
                body: JSON.stringify(body),
            };

            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.classList.add("loading");

            try {
                const response = await fetch(`${routes.cart_add_url}`, config);

                if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);

                const data = await response.json();

                if (data.status) {
                    publish(PUB_SUB_EVENTS.cartError, {
                        source: "bundle-form",
                        productVariantId: formData.get("id"),
                        errors: data.errors || data.description,
                        message: data.message,
                    });

                    this.handleErrorMessage?.(data.description);
                    return;
                }

                publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "bundle-form",
                    productVariantId: "Bundle Builder",
                    cartData: data,
                });

                this.error = false;

                const quickAddModal = this.closest("quick-add-modal");
                if (quickAddModal) {
                    document.body.addEventListener(
                        "modalClosed",
                        () => {
                            setTimeout(() => this.cart.renderContents(data), 0);
                        },
                        { once: true }
                    );
                    quickAddModal.hide(true);
                } else {
                    this.cart.renderContents(data);
                }
            } catch (error) {
                console.error("❌ Fehler beim Hinzufügen zum Warenkorb:", error);
            } finally {
                this.submitButton.classList.remove("loading");
                if (this.cart && this.cart.classList.contains("is-empty"))
                    this.cart.classList.remove("is-empty");
                if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            }
        }

        createBundleId() {
            const random = crypto.getRandomValues(new Uint32Array(4))
                .join('')
                .toString(36)
                .slice(0, 12);
            return `bundle_${random}`;
        }
        calculatePrice() {
            if (!this.data || !this.data.variants) return;
            let total = parseFloat(this.data.base_price) || 0;
            const formData = new FormData(this.form);
            for (const [key, value] of formData.entries()) {
                if (key.includes("single-variant")) {
                    // Preis anhand Variant-ID aus JSON suchen
                    const variant = this.data.variants.find(v => v.id == value);
                    if (variant) total += parseFloat(variant.price);
                }
                else if (key.includes("quantity-variant")) {
                    const parts = key.split("--");
                    const variantId = parts[parts.length - 1];
                    const quantity = parseInt(value, 10);

                    if (quantity > 0) {
                        const variant = this.data.variants.find(v => v.id == variantId);
                        if (variant) total += parseFloat(variant.price) * quantity;
                    }
                }
            }
            const prices = this.data.prices
                .map(p => parseFloat(p))
                .sort((a, b) => a - b);
            let displayPrice = prices[0];

            for (let i = 0; i < prices.length; i++) {
                if (total > prices[i]) {
                    displayPrice = prices[i];
                }
            }
            this.price = displayPrice
            this.compareAtPrice = total

            if (this.calculatePriceElement?.querySelector(".final-price .calculated-price")) {
                this.calculatePriceElement.querySelector(".final-price .calculated-price").innerHTML = displayPrice.toFixed(2).replace(".", ",");
            }
            if (this.calculatePriceElement?.querySelector(".compare-at-price .calculated-price") && displayPrice < total) {
                this.calculatePriceElement.querySelector(".compare-at-price .calculated-price").innerHTML = total.toFixed(2).replace(".", ",");
            }
            if (this.buttonPriceElement.querySelector(".calculated-price")) {
                this.buttonPriceElement.querySelector(".calculated-price").innerHTML = displayPrice.toFixed(2).replace(".", ",");
            }


        }
        togglePrice(isValid) {
            if (isValid) {
                this.calculatePrice()
                this.basePriceElement?.classList.add("hidden")
                this.buttonPriceElement?.classList.remove("hidden")
                this.calculatePriceElement?.classList.remove("hidden")
            } else {
                this.calculatePriceElement?.classList.add("hidden")
                this.buttonPriceElement?.classList.add("hidden")
                this.basePriceElement?.classList.remove("hidden")
            }
        }
    }

    customElements.define("bundle-builder", BundleBuilder);
}



